jQuery(document).ready(function($) {
////////////////////////////////////////////////////////////////////////////// Quiz Page Js Starts/////////////////////////////////////////////////////////////////////////////////////////////////////
      const slides = $('.step-slide');
      const stepIndicator = $('.step-indicator');
      let currentSlideIndex = 0;
      let selectedURL; // To store the URL selected in the 2nd slide
    
      // Show the current slide and hide others
      const showSlide = function(index) {
        slides.hide();
        slides.eq(index).show();
        currentSlideIndex = index;
        updateButtons();
        updateStepIndicator();
      };
    
      // Update the Previous and Next buttons based on the current slide
      const updateButtons = function() {
        $('.prev').toggle(currentSlideIndex > 0);
        $('.next').toggle(currentSlideIndex < slides.length - 1);
        $('.submit').toggle(currentSlideIndex === slides.length - 1);
      };

      // Update the step indicator
  
      const updateStepIndicator = function() {
        const currentStep = currentSlideIndex + 1;
        const mCurrentStep = currentStep -1;
        // 
        $('.step-dot:eq(' + mCurrentStep + ')').addClass('selected');
        console.log(mCurrentStep)
        
        const totalSteps = slides.length - 1; // Exclude the first slide from total steps
        stepIndicator.find('.current-step').text(mCurrentStep);
        stepIndicator.find('.total-steps').text(totalSteps);
      };
    
      // Handle Next button click
      $('.next').click(function() {
        $('.step-indicators').show()
        const currentSlide = slides.eq(currentSlideIndex);
        const shouldValidate = currentSlide.data('validate');
        
        if (shouldValidate) {
          const radios = currentSlide.find('input[type="radio"]');
          if (!radios.is(':checked')) {
            alert('Please select an option before proceeding.');
            return;
          }
        }
    
        if (currentSlideIndex === 1 ) {
          // Save the selected URL from the 2nd slide
          selectedURL = currentSlide.find('input[type="radio"]:checked').val();
        }
    
        showSlide(currentSlideIndex + 1);
      });
    
      // Handle Previous button click
      $('.prev').click(function() {
        showSlide(currentSlideIndex - 1);
        const diFF = currentSlideIndex + 1
        console.log('888888888')
        console.log(diFF)
        console.log('asdasdasd')
        $('.step-dot:eq(' + diFF + ')').removeClass('selected');
      });
    
      // Handle Submit button click (for the last slide)
      jQuery('body').on('click', '.quiz-mail button.go300628013', function($){
        alert('Form submitted')
        jQuery('.klaviyo_form_trigger').trigger('click')
        const currentSlide = slides.eq(currentSlideIndex);
        const shouldValidate = currentSlide.data('validate');
    
        if (shouldValidate) {
          const radios = currentSlide.find('input[type="radio"]');
          if (!radios.is(':checked')) {
            alert('Please select an option before submitting.');
            return;
          }
        }
        const elementExists = jQuery('.go3298969293').length > 0;
        if (elementExists) {
          alert('Please enter valid email')
          return;
          
        }else{
          // Redirect to the selected URL from the 2nd slide
          jQuery('.prev').hide()
          // setTimeout(function($){
            const mattress_type = jQuery('input[name="mattress_type"]:checked').val();
            const mattress_for = jQuery('input[name="mattress_for"]:checked').val();
            const sleeping_position = jQuery('input[name="sleeping_position"]:checked').val();
            const pressure_points = jQuery('input[name="pressure_points"]:checked').val();
            const allergiesVal = jQuery('.allergiesVal').text();
            const bodyTempVal = jQuery('.bodyTempVal').text();
            const priceVal = jQuery('.priceVal').text();
      
            if(mattress_type == 'soft_firm'){
              selectedURL = 'https://lifely.com.au/products/deep-dream-plush-mattress'
            }else if(mattress_type == 'medium_firm'){
              selectedURL = 'https://lifely.com.au/products/deep-dream-premium-mattress'
            }else if(mattress_type == 'super_firm'){
              selectedURL = 'https://lifely.com.au/products/deep-dream-charcoal-mattress'
            }
          
            selectedURL = selectedURL+'?mType='+mattress_type+'&mFor='+mattress_for+'&sPosition='+sleeping_position+'&pPoint='+pressure_points+'&alVal='+allergiesVal+'&btmp='+bodyTempVal+'&prceVal='+priceVal; 
          console.log(selectedURL)
            window.location.href = selectedURL;
      
          // }, 5000)
        }
      });
    
      // Start the form from the first slide
      showSlide(0);
    
      // Show the step indicator from the 2nd slide onwards after the "Get Started" button is clicked
      $('.next').click(function() {
        stepIndicator.show();
      });

  $('body').on('click', '.quizz-radio', function(){
    $('.quizz-radio').removeClass('selected')
    $(this).addClass('selected')
    $('.radio-image').removeClass('selected-img')
    $(this).next().addClass('selected-img')
  })
  $('#allergies').change( function() {  
    if($(this).val() >= 0 & $(this).val() < 25 ){
      $(this).next().text('No allergies')
    }else if($(this).val() == 25){
      $(this).next().text('Yes - sometimes')
    }else if($(this).val() > 25){
      $(this).next().text('Significant allergies')
    }
  });

    $('#bodyTemp').change( function() {  
    if($(this).val() >= 0 & $(this).val() < 25 ){
      $(this).next().text('Just right')
    }else if($(this).val() == 25){
      $(this).next().text('Occasionally too hot')
    }else if($(this).val() > 25){
      $(this).next().text('Always too hot')
    }
  });

    $('#price').change( function() {  
    if($(this).val() >= 0 & $(this).val() < 25 ){
      $(this).next().text('On a budget')
    }else if($(this).val() == 25){
      $(this).next().text('A reasonable price')
    }else if($(this).val() > 25){
      $(this).next().text('I want the best')
    }
  });
  
  
////////////////////////////////////////////////////////////////////////////// Quiz Page Js Ends/////////////////////////////////////////////////////////////////////////////////////////////////////
  
////////////////////////////////////////////////////////////////////////////// Mattress Collection Page Js Starts/////////////////////////////////////////////////////////////////////////////////////////////////////
   $('.text-slider-wrapper').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [
          {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
          {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 400,
           settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });
  $('.rev-img-slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: true,
        centerPadding: '60px',
        autoplaySpeed: 2000,
        arrows: true,
        prevArrow:"<button type='button' class='slick-btn slick-prev'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow:"<button type='button' class='slick-btn slick-next'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          }
        },
        {
           breakpoint: 400,
           settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1
             
           }
        }]
    });

  // Instagram Image slider

  $('.insta-img-slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: true,
        centerPadding: '60px',
        autoplaySpeed: 2000,
        arrows: false,
        prevArrow:"<button type='button' class='slick-btn slick-prev'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow:"<button type='button' class='slick-btn slick-next'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 768,
           settings: {
             centerMode: false,
              slidesToShow: 4,
              slidesToScroll: 1
           }
        }]
    });

  // Instagram image slider end
  
    $('.find-mattress-wrapper').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        prevArrow:"<button type='button' class='slick-btn slick-prev'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow:"<button type='button' class='slick-btn slick-next'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        },
        {
           breakpoint: 400,
           settings: {
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
           }
        }]
    });
////////////////////////////////////////////////////////////////////////////// Mattress Pages Header /////////////////////////////////////////////////////////////////////////////////////////////////////
  
    var submenuVisible = false;

  $(".collection-megamenu").mouseenter(function() {
    // Show the submenu when mouse enters the menu item
    $("#collection-submenu").slideDown();
    submenuVisible = true;
  });

  $(".collection-submenu-wrapper").mouseleave(function(){
    $("#collection-submenu").slideUp();
    submenuVisible = false;
  });

  $("#collection-submenu").mouseenter(function() {
    // Set submenuVisible to true when mouse enters the submenu
    submenuVisible = true;
  }).mouseleave(function() {
    // Set submenuVisible to false when mouse leaves the submenu
    submenuVisible = false;
    setTimeout(function() {
      if (!submenuVisible) {
        $("#collection-submenu").slideUp();
      }
    }, 300); // Delay closing the submenu slightly to allow for a smoother transition
  });

  $(".collection-megamenu").mouseleave(function() {
    // Hide the submenu only when mouse leaves both the menu item and the submenu
    setTimeout(function() {
      if (!submenuVisible) {
        $("#collection-submenu").slideUp();
      }
    }, 300); // Delay closing the submenu slightly to allow for a smoother transition
  });

    var aboutSubmenuVisible = false;
    $(".about-megamenu, #about-submenu").mouseenter(function() {
      // Show the submenu when mouse enters the menu item or the submenu
      $("#about-submenu").slideDown();
      aboutSubmenuVisible = true;
    }).mouseleave(function() {
      // Hide the submenu only when mouse leaves both the menu item and the submenu
      if (!aboutSubmenuVisible) {
        $("#about-submenu").slideUp();
      }
    });
  
    $("#about-submenu").mouseenter(function() {
      // Set aboutSubmenuVisible to true when mouse enters the submenu
      aboutSubmenuVisible = true;
    }).mouseleave(function() {
      // Set aboutSubmenuVisible to false when mouse leaves the submenu
      aboutSubmenuVisible = false;
      $("#about-submenu").slideUp();
    });
  ////////////////////////////////////////////////////////////////////////////// Mattress Product detail Page /////////////////////////////////////////////////////////////////////////////////////////////////////
  $('.reviews-wrapper').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        prevArrow:"<button type='button' class='slick-btn slick-prev'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow:"<button type='button' class='slick-btn slick-next'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        },
        {
           breakpoint: 400,
           settings: {
            arrows: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1
           }
        }]
    });

   $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: true,
      centerMode: true,
      focusOnSelect: true
    });
    $('.main-slider').slick({
      asNavFor: '.thumbnail-slider',
      // Add other Slick options as needed
    });
  
    $('.thumbnail-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.main-slider',
      focusOnSelect: true,
      // Add other Slick options as needed
    });
   
  if ($(window).width() < 768) {
    $('.mattress-product-icon-box').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: true,
    });
    $('.perfect-wrapper').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
    });
  }
  setTimeout(function(){
    $("footer.footer-block__details-content").find("a[href='/pages/return-refunds']").addClass("href");
   // Find the <div> element with the specific class
    var divElement = $("footer.footer-block__details-content").find("div");

    // Find the <a> element with the specific href attribute
    var linkElement = divElement.find("a[href='/pages/return-refunds']");

    // Update the href attribute
    linkElement.attr("href", "/pages/mattress-return-refund");
    linkElement.addClass('22222222222')
  }, 5000)
$('.custom-reviews').click(function(){
    $('html, body').animate({
      scrollTop: $('#judgeme_product_reviews').offset().top
    }, 'slow');
    console.log('aeqwe');
  });
  // $('.review-scroll-down').click(function(){
  // console.log('1111111')
  // });

  $('.open-subMenu-menu').click(function(){
    $('.mobile-collection-submenu-wrapper').slideToggle();
    $(this).toggleClass('open')
  })
    var anchor = $('a[href="/pages/return-refunds"]');
    if (anchor.length > 0) {
        // Replace the anchor's href with "return page redirect" "/pages/mattress-return-refund"
        anchor.attr('href', '/pages/mattress-return-refund');
    }
  
  });
